import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import SearchResult from "./SearchResult";

const SearchBox = () => {
    return (
        <div id="search-box-toggle">
            <div id="search-box-toggle-menu"
                 className="search-box-toggle xpt-2 xpb-2 xpl-1 xpr-1 xpt-lg-2 xpb-lg-2 xpr-lg-16 xpl-lg-16  animate__animated animate__fadeOut animate__faster">
                <div className="search-box position-relative">
                    <input type="text" placeholder="عبارت مورد نظر را وارد کنید..."
                           className="form-control xpt-3 xpb-3 xpr-16 xpl-16 input-search-box"
                           id="search-box-input"/>
                    <div className="search-icon-search-box position-absolute">
                        <IconName name="search" className="icon"/>
                    </div>
                    <div id="close-search-header" className="close-icon-search-box position-absolute">
                        <IconName name="expand_close" className="icon"/>
                    </div>
                    <SearchResult/>
                </div>
            </div>
        </div>
    );
};

export default SearchBox;
